const loc_bg_strings = {
    "Login": {
        "HEADING": "Влизане в платформата FOLBB-ID",
        "LOGIN": "Влизане",
        "USER": "Потребител",
        "PASSWORD": "Парола",
        "LOGIN_FAIL": "Неуспешно влизане",
        "LOGIN_FIELD_REQUIRED": "Полето \"Потребителско име\" е задължително",
        "PASSWORD_FIELD_REQUIRED": "Полето \"Парола\" е задължително",
        "FORGOT_PASSWORD": "Забравена парола?",
        "DIFFERENT_ACCOUNT": "Влизане с различен акаунт",
        "NO_ACCOUNT": "Нямате акаунт?",
        "REGISTER": "Регистрация с my FOLBB",
        "CHANGE_DENIED_TEXT": "Моля, използвайте напр. OWA, за да промените Вашата AD-парола, или се свържете с отдела по поддръжка."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Табло",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Промяна на парола",
        "MY_APPLICATIONS_TEXT": "Моите FOLBB приложения",
        "APPLICATIONS_TEXT": "FOLBB приложения",
        "USERS_LIST_TEXT": "Управление на потребител"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Табло",
        "MY_APPLICATIONS_TEXT": "Моите FOLBB приложения",
        "APPLICATIONS_TEXT": "FOLBB приложения"
    },
    "Header": {
        "USER_MENU_TEXT": "Меню на потребителя",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Промяна на парола",
        "USERS_LIST_TEXT": "Управление на потребител",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Предишна парола",
        "NEW_PASSWORD": "Нова парола",
        "CONFIRM_PASSWORD": "Потвърждаване на паролата",
        "PASS_DO_NOT_MATCH": "Паролите не съвпадат",
        "PASSWORD_FIELD_REQUIRED": "Полето \"Парола\" е задължително",
        "OLD_PASSWORD_FIELD_REQUIRED": "Полето \"Предишна парола\" е задължително",
        "SUCCESS_TEXT": "Паролата е променена успешно",
        "HEADING": "Промяна на идентификационни данни в FOLBB-ID",
        "HELP": "Нуждаете се от помощ?",
        "SAVE": "Промяна",
        "CANCEL": "Отказ",
        "PASSWORD_CHANGE_ERROR": "Данните не бяха записани. Моля, опитайте отново по-късно",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Паролата трябва да съдържа поне 10 символа, да съдържа малки и големи букви, специален знак, цифра",
        "PASSWORD_REQUIREMENTS_TEXT": "Паролата трябва да отговаря на следните изисквания:",
        "LOWERCASE_LETTER_TEXT": "Поне една буква",
        "UPPERCASE_LETTER_TEXT": "Поне една главна буква",
        "NUMBER_TEXT": "Поне едно число",
        "SPECIAL_SYMBOL_TEXT": "Поне един специален символ",
        "PASSWORD_LENGTH_TEXT": "Да съдържа най-малко 10 знака",
        "PASSWORD_RESTRICTION_TEXT": "Личното, фамилното и потребителското име не трябва да са част от паролата",
        "CHANGE_PASSWORD_TEXT": "Промяна на паролата",
        "ACTION_TEXT": "Действия",
        "CHANGE_DENIED_TEXT": "Моля, използвайте напр. OWA, за да промените Вашата AD-парола, или се свържете с отдела по поддръжка."
    },
    "CreatePassword": {
        "PASSWORD": "Създаване на парола",
        "CONFIRM_PASSWORD": "Потвърждаване на паролата",
        "PASS_DO_NOT_MATCH": "Паролите не съвпадат",
        "PASSWORD_FIELD_REQUIRED": "Полето \"Парола\" е задължително",
        "SUCCESS_TEXT": "Данните са записани успешно",
        "HEADING": "Създаване на парола",
        "HELP": "Нуждаете се от помощ?",
        "SAVE": "Промяна",
        "CANCEL": "Отказ",
        "PASSWORD_CHANGE_ERROR": "Данните не бяха записани. Моля, опитайте отново по-късно",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Паролата трябва да съдържа поне 10 символа, малки и главни букви, специален знак, цифра",
        "PASSWORD_REQUIREMENTS_TEXT": "Паролата трябва да отговаря на следните изисквания:",
        "LOWERCASE_LETTER_TEXT": "Поне една буква",
        "UPPERCASE_LETTER_TEXT": "Поне една главна буква",
        "NUMBER_TEXT": "Поне едно число",
        "SPECIAL_SYMBOL_TEXT": "Поне един специален символ",
        "PASSWORD_LENGTH_TEXT": "Да съдържа най-малко 10 знака",
        "PASSWORD_RESTRICTION_TEXT": "Личното, фамилното и потребителското име не трябва да са част от паролата",
        "PASSWORD_WAS_SET": "Линкът вече е използван за задаване на паролата, ако не помните паролата, моля, използвайте функцията за подновяване на парола.",
        "OLD_PASSWORD_REQUIRED": "Полето \"Предишна парола\" е задължително",
        "MMID_CHANGE_PASSWORD": "Промяна на парола",
        "OLD_PASSWORD": "Предишна парола",
        "INVALID_OLD_PASSWORD": "Невалидна предишна парола",
        "USER_NOT_FOUND_OR_INACTIVE": "Потребителят не е намерен или не е активен",
        "UNKNOWN_ERROR": "Възникна грешка при промяна на паролата"
    },
    "ForgotPassword": {
        "USER": "Имейл",
        "LOGIN_FAIL": "Моля, въведете правилен имейл адрес",
        "LOGIN_FIELD_REQUIRED": "Полето \"Имейл\" е задължително",
        "HEADING": "Забравена парола",
        "HELP": "Нуждаете се от помощ?",
        "SAVE": "Изпращане на имейл за подновяване на паролата",
        "CANCEL": "Отказ",
        "SUCCESS_TEXT": "Моля, проверете входящата си поща за получен имейл.",
        "CHANGE_DENIED_TEXT": "Моля, използвайте напр. OWA, за да промените Вашата AD-парола, или се свържете с отдела по поддръжка.",
        "PASSWORD_RESET_TOO_OFTEN": "Функцията за подновяване на паролата е използвана твърде често, моля, опитайте отново по-късно",
        "RESET_FAILED": "Неуспешно влизане",
        "LINK_EXPIRED": "Връзката за влизане е изтекла. Моля, въведете Вашия имейл адрес, за да заявите отново връзката за влизане.",
        "HEADING_EXPIRED": "Вашата връзка за влизане е изтекла",
        "SAVE_EXPIRED": "Заявка за връзка за влизане"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Управление на потребител",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "MMID": "FOLBBID",
        "OU": "Организационна единица",
        "ORGANIZATION_UNIT": "Организационна единица",
        "LANGUAGE": "Език",
        "OPEN_FILTER": "Отваряне на филтър",
        "CLOSE_FILTER": "Затваряне на филтър",
        "RESET": "подновяване",
        "RESET_ALL_FILTERS": "подновяване на всички филтри",
        "SEARCH": "Търсене",
        "STATUS": "Статус",
        "GROUPS": "Групи",
        "SHOW_ALL_DETAILS": "Показване на всички детайли",
        "SHOW_LESS": "Показване на по-малко",
        "ASCENDING": "Възходящ ред",
        "DESCENDING": "Низходящ ред",
        "LIST_END": "Край на списъка",
        "SORT_BY_LASTNAME": "Сортиране по фамилно име",
        "SORT_BY_FIRSTNAME": "Сортиране по лично име",
        "SORT_BY_EMAIL": "Сортиране по имейл",
        "SORT_BY_LANGUAGE": "Сортиране по предпочитан език",
        "SORT_BY_STATUS": "Сортиране по статус",
        "SORT_BY_OU": "Сортиране по OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Редактиране",
        "CREATE": "Нов потребител",
        "DIGICREATE": "Нов потребител на FOLBB digital",
        "ACTIVATE": "Активиране",
        "DEACTIVATE": "Деактивиране",
        "USER_WAS_ACTIVATED": "Потребителят е активиран",
        "USER_WAS_DEACTIVATED": "Потребителят е деактивиран",
        "ERROR_USER_ACTIVATION": "Грешка по време на активирането на потребителя",
        "ERROR_USER_DEACTIVATION": "Грешка по време на деактивирането на потребителя",
        "SEND_FORGOT_PW_EMAIL": "Изпращане на имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Общ имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Имейл от FOLBB digital за забравена парола",
        "COMPANY": "Компания",
        "SEND_WELCOME_EMAIL": "Изпращане на приветствен имейл",
        "SEND_WELCOME_EMAIL_DIGI": "Приветстващ имейл на FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветстващ имейл на FOLBB digital без бутон за парола",
        "APPLY_FILTER_FOR_USERS": "Моля, използвайте филтрите или търсачката за показване на резултатите",
        "GENERATING_EMAIL": "Генериране на имейл ....",
        "ERROR_EMAIL_GENERATE": "Грешка при генериране на имейл ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Управление на потребител",
        "USER_WAS_ACTIVATED": "Потребителят е активиран",
        "USER_WAS_DEACTIVATED": "Потребителят е деактивиран",
        "ERROR_USER_ACTIVATION": "Грешка по време на активирането на потребител",
        "ERROR_USER_DEACTIVATION": "Грешка по време на деактивирането на потребител",
        "LOADING_USER_ERROR": "Грешка при зареждане на потребител",
        "FIRSTNAME": "Лично име",
        "LASTNAME": "Фамилно име",
        "EMAIL": "Имейл",
        "ACCOUNT_NAME": "Потребителско име за влизане (по-стари версии от Windows 2000)",
        "LANGUAGE": "Език",
        "PRINCIPAL_NAME": "Основно име на потребителя",
        "OU": "Организационна единица",
        "CLASS_DISPLAY_NAME": "Показване на името",
        "PHONE": "Телефон",
        "WEBSITE": "Уебсайт",
        "COUNTRY": "Държава",
        "STATE": "Щат",
        "LOCATION": "Град",
        "STREET": "Улица",
        "POSTAL_CODE": "Пощенски код",
        "COMPANY": "Компания",
        "DEPARTMENT": "Отдел",
        "PERSONAL_TITLE": "Лично обръщение",
        "MANAGER": "Ръководител",
        "DESCRIPTION": "Описание",
        "GROUPS": "Групи",
        "SAVE": "Записване",
        "CANCEL": "Отказ",
        "USER_STATUS": "Статус на потребителя",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "ACTIVATE": "Активиране",
        "DEACTIVATE": "Деактивиране",
        "USER_WAS_SAVED": "Потребителят е записан",
        "UNKNOWN_ERROR": "Възникна неизвестна грешка при записване на потребителя",
        "PROXY_ADDRESSES": "Прокси адреси",
        "BROWSE": "Търсене",
        "REMOVE": "Премахване",
        "ONLY_JPG": "Позволени са само изображения jpg!",
        "FILE_SIZE": "Размерът на файла трябва да е по-малък от 100КВ!",
        "DIMENSIONS": "Максималните размери на изображенията са 96х96 пиксела!",
        "SEND_FORGOT_PW_EMAIL": "Изпращане на имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Общ имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Имейл от FOLBB digital за забравена парола",
        "VIRUS_FOUND": "Потребителят не бе записан. В приложението бе открит зловреден софтуер. Файлът няма да бъде качен. Моля, свържете се с Вашия системен администратор.",
        "VIRUS_SCANNER_NOT_AVL": "Сканирането на файла за зловреден софтуер бе неуспешно. Моля, опитайте отново по-късно. Ако проблемът продължи, свържете се с Вашия системен администратор.",
        "INFO": "Информация:",
        "SEND_WELCOME_EMAIL": "Изпращане на приветстващ имейл",
        "SEND_WELCOME_EMAIL_DIGI": "Приветстващ имейл на FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветстващ имейл на FOLBB digital без бутон за парола",
        "SAVING_USER_SPINNER": "Записване на потребител... Моля, изчакайте",
        "DUPLICATE_USER": "Потребителят вече съществува",
        "GENERATING_EMAIL": "Генериране на имейл ....",
        "ERROR_EMAIL_GENERATE": "Грешка при генериране на имейл ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Потребителят не е намерен",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Потребителят е активиран",
        "USER_WAS_DEACTIVATED": "Потребителят е деактивиран",
        "ERROR_USER_ACTIVATION": "Грешка по време на активиране на потребител",
        "ERROR_USER_DEACTIVATION": "Грешка по време на деактивиране на потребител",
        "EMAIL_WAS_SENT": "Имейлът е изпратен успешно",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Имейлът не бе изпратен. Потребителят вече е активен. Вместо това, използвайте функцията \"Изпращане на имейл за забравена парола\"",
        "ERROR_EMAIL_SEND": "Грешка при опита за изпращане на имейл",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Имейлът не бе изпратен. Потребителят е неактивен. Използвайте функция \"Изпращане на имейл за регистрация в FOLBB digital\".",
        "PASSWORD_RESET_TOO_OFTEN": "Функцията за подновяване на паролата е използвана твърде често, моля, опитайте отново по-късно",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Генериране на добре дошли електронна поща ...."
    }
};

export default loc_bg_strings;



// WEBPACK FOOTER //
// ./src/resources/bg.js